import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'
import './reCaptcha.css'
import { withTranslation } from "react-i18next"

class ReCaptcha extends Component
{
    static propTypes = {
        recaptchaKey: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    }

    render()
    {
        const { t } = this.props

        return (
            <div className={'form-group'}>
                <div>
                    <ReCAPTCHA
                        className={'recaptcha-container'}
                        sitekey={this.props.recaptchaKey}
                        hl={this.props.locale}
                        size="compact"
                        theme="dark"
                        onChange={this.props.onChange}
                    />
                </div>
                <div id={'recaptcha-disclaimer'}>
                    <label>{(t('visualizer:captcha.consents'))}</label>
                </div>
            </div>
        )
    }
}

export default withTranslation()(ReCaptcha)
